export default __webpack_public_path__ + "static/media/2.d6b57a9d.webp";